
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(1 3)","fill":"none","fill-rule":"evenodd"}},[_c('ellipse',{attrs:{"fill":"#D1D6E0","cx":"12.815","cy":"12.698","rx":"12.815","ry":"12.698"}}),_c('path',{attrs:{"d":"M20.503 7.995c5.41 0 7.594 3.01 8.733 7.713l.095.282 2.753 5.55c.38.752.095 1.599-.665 1.975-.19.094-.284.094-.474.094h-.95v3.574c0 1.411-1.044 2.54-2.467 2.634h-2.753v4.233h-2.183v-6.302h4.746c.19 0 .38-.189.474-.377V21.446h1.899l-2.278-4.61-.095-.282c-.855-4.138-2.468-6.396-6.645-6.396-4.746 0-7.784 3.48-7.784 7.525 0 2.258.38 3.763 1.52 6.114l.379.847.19.376c1.613 3.104 2.278 5.267 2.373 8.56v.658h-2.468c0-3.01-.475-4.891-1.804-7.62l-.57-1.222c-1.423-2.916-1.993-4.703-1.993-7.619 0-5.267 3.892-9.782 9.967-9.782zM43 27.465c0 4.045-1.614 7.807-4.272 10.535l-1.613-1.599c2.278-2.351 3.607-5.455 3.607-9.03 0-3.668-1.519-7.054-3.987-9.406l1.519-1.599C41.196 19.282 43 23.14 43 27.466zm-4.746 0c0 2.822-1.14 5.362-2.848 7.243l-1.614-1.6c1.424-1.504 2.279-3.48 2.279-5.643 0-2.351-1.045-4.515-2.658-6.02l1.613-1.598c1.994 1.88 3.228 4.608 3.228 7.618z","fill":"#171C26"}})])])
          )
        }
      }
    